import { gql } from '@apollo/client';
import { AccountKind } from '../models/accounts/accountKind';
import { PlanType, RenewalOptions } from '../models';
import { EmployerModuleType } from '../models/accounts/employerModuleType';
import { ManagementControls } from '../models/managementControls';

export const GET_TRANSACTION_STATISTICS = gql`
  query GetEmployerStatistics($employerId: UUID!) {
    employerStatistics(employerId: $employerId) {
      employeeSpend {
        totalSpend
        totalTransactions
        monthlyStats {
          month
          year
          totalAmount
          transactionCount
        }
        currentMonthDailyStats {
          date
          totalAmount
          transactionCount
        }
      }
    }
  }
`;

export const CREATE_REWARD_SENDING_PLAN = gql`
  mutation createRewardPlan($employerId: UUID!, $request: CreatePlanRequestInput!) {
    createRewardSendingPlan(employerId: $employerId, request: $request)
  }
`;

export interface MonthlyStats {
  month: number;
  year: number;
  totalAmount: number;
  transactionCount: number;
}

export interface DailyStats {
  date: string;
  totalAmount: number;
  transactionCount: number;
}

export interface EmployeeSpend {
  totalSpend: number;
  totalTransactions: number;
  monthlyStats: MonthlyStats[];
  currentMonthDailyStats: DailyStats[];
}

export interface EmployerStatistics {
  employeeSpend: EmployeeSpend;
}

export interface EmployerStatisticsData {
  employerStatistics: EmployerStatistics;
}

export interface EmployerStatisticsVars {
  employerId: string;
}

export interface ServiceSectorReference {
  id: string;
  name: string;
}

export interface PurchaseControls {
  isEnabled: boolean;
}

export interface PaymentControls {
  isEnabled: boolean;
  allowedTargetPlans?: string[];
  reasonCategories?: string[];
}

export interface Controls {
  purchases: PurchaseControls;
  payments: PaymentControls;
  management: ManagementControls;
  serviceSectors?: ServiceSectorReference[];
}

export interface TierRequest {
  name: string,
  amount: number
}

export interface CreatePlanRequestInput {
  employerId: string;
  request: { 
    name: string,
    accountKind: AccountKind, 
    type: PlanType, 
    employerModuleType: EmployerModuleType, 
    controls: Controls 
    renewalOptions: RenewalOptions,
    serviceSectorIds: string[],
    tiers: TierRequest[]
  };
} 